export const HEADER_HEIGHT = 56;
export const DEFAULT_STAT_CARD_HEIGHT = 187 - HEADER_HEIGHT;
export const DEFAULT_CARD_CONTENT_HEIGHT = 300 - HEADER_HEIGHT;
export const DATA_CARD_FOOTER_HEIGHT = 70;
export const DEFAULT_STAT_CARD_BODY_HEIGHT = 53;
